import { getIsEmbedded } from "./params";

export const validateSirvUrl = (rule, value, callback) => {
  try {
    const isEmbedded = getIsEmbedded();
    const url = new URL(value);
    // URLs outside sirv.com will break the viewer, so reject them
    if (url.hostname.search(/sirv\.com$/) === -1) {
      callback("Resource must be hosted on sirv.com");
      return;
    }
    // If isEmbedded is true, check if the path ends with .spin
    if (isEmbedded && !url.pathname.endsWith(".spin")) {
      callback("URL must end with .spin");
      return;
    }
    // If all checks pass, call the callback with no error
    callback();
  } catch (error) {
    // Handle URL parsing errors, e.g., invalid URL
    callback("Invalid URL");
  }
};
